import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../components/layout";
import ProcessList from "../../components/processes/ProcessList";
import { useAppSelector } from "../../app/hooks";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { getSelectedBranch } from "../../features/settings/settingsSlice";
import { useCanAccess } from "../../hooks/useCanAccess";
import { t } from "../../locales";
import { route } from "../../static/route";

const ProcessesPage = () => {
  const navigate = useNavigate();
  const canAccess = useCanAccess();
  const loggingUser = useAppSelector(getLoggingUser);
  const selectedBranch = useAppSelector(getSelectedBranch);

  useEffect(() => {
    if (loggingUser?.permissions && selectedBranch && !canAccess("processes.menu")) {
      navigate(route.dashboard);
    }
  }, [loggingUser, selectedBranch]);

  return (
    <Layout>
      <div className="px-2 py-4 md:px-6 md:py-6">
        {/* Breadcrumb */}
        <nav className="text-sm font-semibold text-gray-500 mb-4">
          <Link
            to={route.dashboard}
            className="text-brand-dark hover:underline"
          >
            {t.processes.breadcrumbHome}
          </Link>
          <span className="mx-2">&rsaquo;</span>
          <span className="text-gray-500">{t.processes.breadcrumbProcesses}</span>
        </nav>

        {/* Page title */}
        <h1 className="text-2xl font-bold text-brand-dark mb-6">
          {t.processes.pageTitle}
        </h1>

        <ProcessList />
      </div>
    </Layout>
  );
};

export default ProcessesPage;
